(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 35410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ spin; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/omit.js

function omit(obj, fields) {
  var clone = (0,objectSpread2/* default */.Z)({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function (key) {
      delete clone[key];
    });
  }
  return clone;
}
;// CONCATENATED MODULE: ./node_modules/throttle-debounce/esm/index.js
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle (delay, callback, options) {
  var _ref = options || {},
      _ref$noTrailing = _ref.noTrailing,
      noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
      _ref$noLeading = _ref.noLeading,
      noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
      _ref$debounceMode = _ref.debounceMode,
      debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */


  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel(options) {
    var _ref2 = options || {},
        _ref2$upcomingOnly = _ref2.upcomingOnly,
        upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;

    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();

        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, callback, options) {
  var _ref = options || {},
      _ref$atBegin = _ref.atBegin,
      atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;

  return throttle(delay, callback, {
    debounceMode: atBegin !== false
  });
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/antd/es/_util/reactNode.js

const {
  isValidElement
} = react_namespaceObject;
function isFragment(child) {
  return child && isValidElement(child) && child.type === React.Fragment;
}
function replaceElement(element, replacement, props) {
  if (!isValidElement(element)) {
    return replacement;
  }
  return /*#__PURE__*/react.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
function cloneElement(element, props) {
  return replaceElement(element, element, props);
}
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(53124);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 25 modules
var es = __webpack_require__(92950);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(14747);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genComponentStyleHook.js + 19 modules
var genComponentStyleHook = __webpack_require__(10492);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/statistic.js
var statistic = __webpack_require__(45503);
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/style/index.js
"use client";




const antSpinMove = new es/* Keyframes */.E4('antSpinMove', {
  to: {
    opacity: 1
  }
});
const antRotate = new es/* Keyframes */.E4('antRotate', {
  to: {
    transform: 'rotate(405deg)'
  }
});
const genSpinStyle = token => ({
  [`${token.componentCls}`]: Object.assign(Object.assign({}, (0,style/* resetComponent */.Wf)(token)), {
    position: 'absolute',
    display: 'none',
    color: token.colorPrimary,
    fontSize: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    opacity: 0,
    transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
    '&-spinning': {
      position: 'static',
      display: 'inline-block',
      opacity: 1
    },
    '&-nested-loading': {
      position: 'relative',
      [`> div > ${token.componentCls}`]: {
        position: 'absolute',
        top: 0,
        insetInlineStart: 0,
        zIndex: 4,
        display: 'block',
        width: '100%',
        height: '100%',
        maxHeight: token.contentHeight,
        [`${token.componentCls}-dot`]: {
          position: 'absolute',
          top: '50%',
          insetInlineStart: '50%',
          margin: -token.dotSize / 2
        },
        [`${token.componentCls}-text`]: {
          position: 'absolute',
          top: '50%',
          width: '100%',
          paddingTop: (token.dotSize - token.fontSize) / 2 + 2,
          textShadow: `0 1px 2px ${token.colorBgContainer}`,
          fontSize: token.fontSize
        },
        [`&${token.componentCls}-show-text ${token.componentCls}-dot`]: {
          marginTop: -(token.dotSize / 2) - 10
        },
        '&-sm': {
          [`${token.componentCls}-dot`]: {
            margin: -token.dotSizeSM / 2
          },
          [`${token.componentCls}-text`]: {
            paddingTop: (token.dotSizeSM - token.fontSize) / 2 + 2
          },
          [`&${token.componentCls}-show-text ${token.componentCls}-dot`]: {
            marginTop: -(token.dotSizeSM / 2) - 10
          }
        },
        '&-lg': {
          [`${token.componentCls}-dot`]: {
            margin: -(token.dotSizeLG / 2)
          },
          [`${token.componentCls}-text`]: {
            paddingTop: (token.dotSizeLG - token.fontSize) / 2 + 2
          },
          [`&${token.componentCls}-show-text ${token.componentCls}-dot`]: {
            marginTop: -(token.dotSizeLG / 2) - 10
          }
        }
      },
      [`${token.componentCls}-container`]: {
        position: 'relative',
        transition: `opacity ${token.motionDurationSlow}`,
        '&::after': {
          position: 'absolute',
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          zIndex: 10,
          width: '100%',
          height: '100%',
          background: token.colorBgContainer,
          opacity: 0,
          transition: `all ${token.motionDurationSlow}`,
          content: '""',
          pointerEvents: 'none'
        }
      },
      [`${token.componentCls}-blur`]: {
        clear: 'both',
        opacity: 0.5,
        userSelect: 'none',
        pointerEvents: 'none',
        [`&::after`]: {
          opacity: 0.4,
          pointerEvents: 'auto'
        }
      }
    },
    // tip
    // ------------------------------
    [`&-tip`]: {
      color: token.spinDotDefault
    },
    // dots
    // ------------------------------
    [`${token.componentCls}-dot`]: {
      position: 'relative',
      display: 'inline-block',
      fontSize: token.dotSize,
      width: '1em',
      height: '1em',
      '&-item': {
        position: 'absolute',
        display: 'block',
        width: (token.dotSize - token.marginXXS / 2) / 2,
        height: (token.dotSize - token.marginXXS / 2) / 2,
        backgroundColor: token.colorPrimary,
        borderRadius: '100%',
        transform: 'scale(0.75)',
        transformOrigin: '50% 50%',
        opacity: 0.3,
        animationName: antSpinMove,
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
        animationDirection: 'alternate',
        '&:nth-child(1)': {
          top: 0,
          insetInlineStart: 0
        },
        '&:nth-child(2)': {
          top: 0,
          insetInlineEnd: 0,
          animationDelay: '0.4s'
        },
        '&:nth-child(3)': {
          insetInlineEnd: 0,
          bottom: 0,
          animationDelay: '0.8s'
        },
        '&:nth-child(4)': {
          bottom: 0,
          insetInlineStart: 0,
          animationDelay: '1.2s'
        }
      },
      '&-spin': {
        transform: 'rotate(45deg)',
        animationName: antRotate,
        animationDuration: '1.2s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear'
      }
    },
    // Sizes
    // ------------------------------
    // small
    [`&-sm ${token.componentCls}-dot`]: {
      fontSize: token.dotSizeSM,
      i: {
        width: (token.dotSizeSM - token.marginXXS / 2) / 2,
        height: (token.dotSizeSM - token.marginXXS / 2) / 2
      }
    },
    // large
    [`&-lg ${token.componentCls}-dot`]: {
      fontSize: token.dotSizeLG,
      i: {
        width: (token.dotSizeLG - token.marginXXS) / 2,
        height: (token.dotSizeLG - token.marginXXS) / 2
      }
    },
    [`&${token.componentCls}-show-text ${token.componentCls}-text`]: {
      display: 'block'
    }
  })
});
// ============================== Export ==============================
/* harmony default export */ var spin_style = ((0,genComponentStyleHook/* default */.Z)('Spin', token => {
  const spinToken = (0,statistic/* merge */.TS)(token, {
    spinDotDefault: token.colorTextDescription
  });
  return [genSpinStyle(spinToken)];
}, token => ({
  contentHeight: 400,
  dotSize: token.controlHeightLG / 2,
  dotSizeSM: token.controlHeightLG * 0.35,
  dotSizeLG: token.controlHeight
})));
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/index.js
"use client";

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








const SpinSizes = (/* unused pure expression or super */ null && (['small', 'default', 'large']));
// Render indicator
let defaultIndicator = null;
function renderIndicator(prefixCls, props) {
  const {
    indicator
  } = props;
  const dotClassName = `${prefixCls}-dot`;
  // should not be render default indicator when indicator value is null
  if (indicator === null) {
    return null;
  }
  if (isValidElement(indicator)) {
    return cloneElement(indicator, {
      className: classnames_default()(indicator.props.className, dotClassName)
    });
  }
  if (isValidElement(defaultIndicator)) {
    return cloneElement(defaultIndicator, {
      className: classnames_default()(defaultIndicator.props.className, dotClassName)
    });
  }
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(dotClassName, `${prefixCls}-dot-spin`)
  }, /*#__PURE__*/react.createElement("i", {
    className: `${prefixCls}-dot-item`,
    key: 1
  }), /*#__PURE__*/react.createElement("i", {
    className: `${prefixCls}-dot-item`,
    key: 2
  }), /*#__PURE__*/react.createElement("i", {
    className: `${prefixCls}-dot-item`,
    key: 3
  }), /*#__PURE__*/react.createElement("i", {
    className: `${prefixCls}-dot-item`,
    key: 4
  }));
}
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}
const Spin = props => {
  const {
      spinPrefixCls: prefixCls,
      spinning: customSpinning = true,
      delay = 0,
      className,
      rootClassName,
      size = 'default',
      tip,
      wrapperClassName,
      style,
      children,
      hashId
    } = props,
    restProps = __rest(props, ["spinPrefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "hashId"]);
  const [spinning, setSpinning] = react.useState(() => customSpinning && !shouldDelay(customSpinning, delay));
  react.useEffect(() => {
    if (customSpinning) {
      const showSpinning = debounce(delay, () => {
        setSpinning(true);
      });
      showSpinning();
      return () => {
        var _a;
        (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 ? void 0 : _a.call(showSpinning);
      };
    }
    setSpinning(false);
  }, [delay, customSpinning]);
  const isNestedPattern = react.useMemo(() => typeof children !== 'undefined', [children]);
  if (false) {}
  const {
    direction,
    spin
  } = react.useContext(context/* ConfigContext */.E_);
  const spinClassName = classnames_default()(prefixCls, spin === null || spin === void 0 ? void 0 : spin.className, {
    [`${prefixCls}-sm`]: size === 'small',
    [`${prefixCls}-lg`]: size === 'large',
    [`${prefixCls}-spinning`]: spinning,
    [`${prefixCls}-show-text`]: !!tip,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, className, rootClassName, hashId);
  const containerClassName = classnames_default()(`${prefixCls}-container`, {
    [`${prefixCls}-blur`]: spinning
  });
  // fix https://fb.me/react-unknown-prop
  const divProps = omit(restProps, ['indicator', 'prefixCls']);
  const mergedStyle = Object.assign(Object.assign({}, spin === null || spin === void 0 ? void 0 : spin.style), style);
  const spinElement = /*#__PURE__*/react.createElement("div", Object.assign({}, divProps, {
    style: mergedStyle,
    className: spinClassName,
    "aria-live": "polite",
    "aria-busy": spinning
  }), renderIndicator(prefixCls, props), tip && isNestedPattern ? /*#__PURE__*/react.createElement("div", {
    className: `${prefixCls}-text`
  }, tip) : null);
  if (isNestedPattern) {
    return /*#__PURE__*/react.createElement("div", Object.assign({}, divProps, {
      className: classnames_default()(`${prefixCls}-nested-loading`, wrapperClassName, hashId)
    }), spinning && /*#__PURE__*/react.createElement("div", {
      key: "loading"
    }, spinElement), /*#__PURE__*/react.createElement("div", {
      className: containerClassName,
      key: "container"
    }, children));
  }
  return spinElement;
};
const SpinFC = props => {
  const {
    prefixCls: customizePrefixCls
  } = props;
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const spinPrefixCls = getPrefixCls('spin', customizePrefixCls);
  const [wrapSSR, hashId] = spin_style(spinPrefixCls);
  const spinClassProps = Object.assign(Object.assign({}, props), {
    spinPrefixCls,
    hashId
  });
  return wrapSSR( /*#__PURE__*/react.createElement(Spin, Object.assign({}, spinClassProps)));
};
SpinFC.setDefaultIndicator = indicator => {
  defaultIndicator = indicator;
};
if (false) {}
/* harmony default export */ var spin = (SpinFC);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9021);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53918);
/* harmony import */ var _Box_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6538);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43605);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71849);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: ",
        ";\n    border-radius: 12px;\n    ",
        " {\n        padding-left: ",
        ";\n        padding-right: ",
        ";\n        background-color: transparent;\n        font-weight: 700;\n        font-size: 14px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    align-items: center;\n    display: flex;\n    height: 100%;\n    position: absolute;\n    top: 0;\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var getPadding = function(scale, hasIcon) {
    if (!hasIcon) {
        return "16px";
    }
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.LG */ .Q.LG:
            return "56px";
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.MD */ .Q.MD:
        default:
            return "48px";
    }
};
var StyledInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Box_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-809825c4-0"
})(_templateObject(), function(param) {
    var isHiddenBorder = param.isHiddenBorder, theme = param.theme;
    return isHiddenBorder ? "none" : "1px solid ".concat(theme.colors.cardBorder);
}, _Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, function(param) {
    var hasStartIcon = param.hasStartIcon, scale = param.scale;
    return getPadding(scale, hasStartIcon);
}, function(param) {
    var hasEndIcon = param.hasEndIcon, scale = param.scale;
    return getPadding(scale, hasEndIcon);
});
var InputIcon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-809825c4-1"
})(_templateObject1(), function(param) {
    var isEndIcon = param.isEndIcon, scale = param.scale;
    return isEndIcon ? "\n    right: ".concat(scale === _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM ? "8px" : "16px", ";\n  ") : "\n    left: ".concat(scale === _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM ? "8px" : "16px", ";\n  ");
});
var InputGroup = function(_param) /*#__PURE__*/ {
    var _scale = _param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.MD */ .Q.MD : _scale, startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "scale",
        "startIcon",
        "endIcon",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledInputGroup, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        scale: scale,
        width: "100%",
        position: "relative",
        hasStartIcon: !!startIcon,
        hasEndIcon: !!endIcon
    }, props), {
        children: [
            startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputIcon, {
                scale: scale,
                children: startIcon
            }),
            /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(children, {
                scale: scale
            }),
            endIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputIcon, {
                scale: scale,
                isEndIcon: true,
                children: endIcon
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputGroup);


/***/ }),

/***/ 85621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53918);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74566);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76376);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19881);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43605);
/* harmony import */ var utils_latinise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75660);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);







function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 16px;\n    transition: border-radius 0.15s;\n    color: #fdb533;\n    > svg {\n        fill: #fff !important;\n    }\n\n    @media screen and (max-width: 600px) {\n        padding: 0 10px;\n        width: 80%;\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 16px;\n    @media screen and (max-width: 600px) {\n        font-size: 15px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 180px;\n    height: 100%;\n    max-height: 250px;\n    padding: 0px;\n    position: absolute;\n    overflow-y: auto;\n    overflow-x: hidden;\n    z-index: ",
        ";\n    transition: transform 0.15s, opacity 0.15s;\n    transform: scaleY(0);\n    transform-origin: top;\n    opacity: 0;\n    box-sizing: border-box;\n    box-shadow: 0px 8px 28px 0px rgba(66, 66, 66, 0.10);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            ",
        " {\n                height: auto;\n                transform: scaleY(1);\n                opacity: 1;\n                border-top-width: 0;\n                width: 100%;\n                background: ",
        ";\n                top: 49px;\n                border-radius: 12px;\n                z-index: 20;\n            }\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    height: 48px;\n    border-radius: 12px;\n    box-sizing: border-box;\n    background-color: transparent;\n    border: 1px solid ",
        ";\n    ",
        " {\n        min-width: 100px;\n    }\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 0;\n    box-sizing: border-box;\n    z-index: ",
        ";\n    /* display: ",
        "; */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    list-style: none;\n    padding: 8px 28px;\n    border-radius: 0px;\n    :hover {\n        background: ",
        ";\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var DropDownHeader = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64f50ac5-0"
})(_templateObject());
var CsText = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-64f50ac5-1"
})(_templateObject1());
var DropDownListContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64f50ac5-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var DropDownContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64f50ac5-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject3(), DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.background;
    });
});
var DropDownList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-64f50ac5-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "none" : "block";
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-64f50ac5-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt2;
});
var SelectProvinceHome = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, placeHolderText = _param.placeHolderText, isDefaultProvince = _param.isDefaultProvince, isLoading = _param.isLoading, selectedOption = _param.selectedOption, disabled = _param.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "options",
        "onOptionChange",
        "placeHolderText",
        "isDefaultProvince",
        "isLoading",
        "selectedOption",
        "disabled"
    ]);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        width: 0,
        height: 0
    }), containerSize = ref2[0], setContainerSize = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(options)), filterData = ref3[0], setFillterData = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), query = ref4[0], setQuery = ref4[1];
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().theme;
    var toggling = function(event) {
        if (options.length > 0 && !disabled) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var handleClicked = function(data) {
        return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                setIsOpen(false);
                setOptionSelected(true);
                setQuery("");
                if (onOptionChange) {
                    onOptionChange(data);
                }
                return [
                    2
                ];
            });
        });
    };
    var handleClickOutside = function() {
        if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
            setIsOpen(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    var handleChangeQuery = function(event) {
        console.log("event", event);
        var re = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\W|_]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            var values = event.target.value;
            var replace = values.replace(/[.*+?^${}()|[\]\\!@#%&_~]/g, "");
            setQuery(replace);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var lowercaseQuery = (0,utils_latinise__WEBPACK_IMPORTED_MODULE_4__/* .toLowerCaseNonAccentVietnamese */ .HO)(query.toLowerCase());
        if ((query === null || query === void 0 ? void 0 : query.length) > 0) {
            setFillterData((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(options.filter(function(it) {
                return (0,utils_latinise__WEBPACK_IMPORTED_MODULE_4__/* .toLowerCaseNonAccentVietnamese */ .HO)(it === null || it === void 0 ? void 0 : it.provinceName.toLowerCase()).includes(lowercaseQuery);
            })));
        } else {
            setFillterData((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(options));
        }
    }, [
        options,
        query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isDefaultProvince && !optionSelected) {
            onOptionChange({
                provinceId: "0",
                provinceName: "Tất cả"
            });
        }
    }, [
        isDefaultProvince,
        onOptionChange,
        optionSelected
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        isOpen: isOpen
    }, props), {
        ref: containerRef
    }), containerSize), {
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsText, {
                    color: !optionSelected && placeHolderText ? "text" : "text",
                    children: selectedOption === undefined ? "Tất cả khu vực" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: "Loading..."
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: (options === null || options === void 0 ? void 0 : options.length) === 0 ? "Kh\xf4ng c\xf3 tỉnh th\xe0nh" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: !optionSelected && placeHolderText ? placeHolderText : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceName
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                position: "absolute",
                right: "16px",
                top: "13px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    color: "black",
                    onClick: toggling,
                    style: {
                        transform: isOpen && "rotate(180deg)"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownListContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        width: "100%",
                        height: "auto",
                        padding: "12px 12px 0px 12px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}),
                            mb: "2px",
                            scale: "sm",
                            isHiddenBorder: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                type: "text",
                                placeholder: "T\xecm kiếm",
                                value: query,
                                onChange: function(evt) {
                                    return handleChangeQuery(evt);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        width: "100%",
                        borderBottom: "1px solid ".concat(theme.colors.backgroundTab)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownList, {
                        ref: dropdownRef,
                        isDisabled: isLoading,
                        children: filterData.map(function(option) {
                            return placeHolderText || (option === null || option === void 0 ? void 0 : option.provinceId) !== (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, {
                                onClick: handleClicked(option),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CsText, {
                                    color: (option === null || option === void 0 ? void 0 : option.provinceId) === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId) ? "gold" : "text",
                                    children: [
                                        option === null || option === void 0 ? void 0 : option.provinceName,
                                        " ",
                                        (option === null || option === void 0 ? void 0 : option.amount) && "(".concat(option === null || option === void 0 ? void 0 : option.amount, ")"),
                                        " "
                                    ]
                                })
                            }, option === null || option === void 0 ? void 0 : option.provinceName) : null;
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectProvinceHome);


/***/ }),

/***/ 9021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 6 modules
var wagmi = __webpack_require__(92835);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./src/state/home/index.ts + 1 modules
var home = __webpack_require__(11158);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/home/actions.ts
var actions = __webpack_require__(51302);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(55421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowLeft.tsx
var ArrowLeft = __webpack_require__(5453);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(21023);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(48999);
;// CONCATENATED MODULE: ./src/components/ToolTip3/index.tsx







var LightTooltip3 = (0,styled_components_browser_esm/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        placement: "top",
        arrow: true,
        classes: {
            popper: className
        },
        enterTouchDelay: 100
    }));
}).withConfig({
    componentId: "sc-f87bb3d-0"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "white",
        "&::before": {
            backgroundColor: "#f5f5f5"
        }
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#f5f5f5",
        color: "#000000",
        boxShadow: "red",
        fontSize: 12,
        padding: 10,
        fontWeight: 500
    }), _obj;
});

// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
;// CONCATENATED MODULE: ./src/views/Home/Brand/components/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    grid-gap: 1rem;\n    @media screen and (max-width:600px) {\n        grid-template-columns: repeat(4, 1fr);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 92px;\n    border-radius: 12px;\n    align-items: center;\n    padding: 0rem 8px;\n    background:",
        ";\n    justify-content: space-around;\n    @media screen and (max-width:600px) {\n        flex-wrap:wrap;\n        justify-content:space-between;\n        gap: 1.5rem;\n        height: auto;\n        padding: 1rem;\n        padding-bottom: 1.5rem;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 137.708px;\n    height: 52px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ",
        "{\n        font-size: 13px;\n    }\n    cursor: pointer;\n    @media screen and (max-width:600px) {\n        width: 45%;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 40px;\n    @media screen and (max-width:600px) {\n        font-size: 22px;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var GridTemplate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9237abe-0"
})(_templateObject());
var ContainerPrice = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b9237abe-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientBubblegum;
});
var Card = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b9237abe-2"
})(_templateObject2(), Text/* default */.Z);
var CsTagPrice = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b9237abe-3"
})(_templateObject3());
var CsHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-b9237abe-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/views/Home/Brand/components/LessBrand.tsx







var LessBrand = function(param) {
    var activePrice = param.activePrice, handleChangePrice = param.handleChangePrice, handleShowMore = param.handleShowMore, ListBrand = param.ListBrand;
    var ref;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var filterHasImg = ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.images) !== "";
    });
    var countListBrandMore = (ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.length) - (filterHasImg === null || filterHasImg === void 0 ? void 0 : filterHasImg.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        style: {
            gap: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                mb: "1rem",
                mt: "2rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    scale: "xl",
                    children: "Thương hiệu nổi bật"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridTemplate, {
                children: (ref = filterHasImg === null || filterHasImg === void 0 ? void 0 : filterHasImg.slice(0, 18)) === null || ref === void 0 ? void 0 : ref.map(function(dt) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (dt === null || dt === void 0 ? void 0 : dt.isNewBrand) ? "/brand/".concat(dt === null || dt === void 0 ? void 0 : dt.id, "?newbrand=true") : "/brand/".concat(dt === null || dt === void 0 ? void 0 : dt.id),
                        children: (dt === null || dt === void 0 ? void 0 : dt.images) !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            height: "auto",
                            borderRadius: "10px",
                            border: "1px solid ".concat(theme.colors.silver),
                            style: {
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: dt === null || dt === void 0 ? void 0 : dt.images,
                                alt: dt === null || dt === void 0 ? void 0 : dt.title,
                                style: {
                                    borderRadius: "9px"
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                title: dt === null || dt === void 0 ? void 0 : dt.title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/logo/noLogo.png",
                                            alt: dt === null || dt === void 0 ? void 0 : dt.title
                                        })
                                    })
                                })
                            })
                        })
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                mt: "1rem",
                mb: "3rem",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary",
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {}),
                    onClick: function() {
                        return handleShowMore(!false);
                    },
                    children: "+ 300 thương hiệu"
                })
            })
        ]
    });
};
/* harmony default export */ var components_LessBrand = (LessBrand);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowLeftCircle.tsx
var ArrowLeftCircle = __webpack_require__(41061);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/InputGroup.tsx
var InputGroup = __webpack_require__(76376);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Search.tsx
var Search = __webpack_require__(19881);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(43605);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/components/Select/SelectProvinceHome.tsx
var SelectProvinceHome = __webpack_require__(85621);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/config/constants/address/province.json
var province = __webpack_require__(8126);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(95867);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 4 modules
var spin = __webpack_require__(35410);
;// CONCATENATED MODULE: ./src/views/Home/Brand/components/MoreBrand.tsx




function MoreBrand_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 250px;\n    @media screen and (max-width:1280px) and (min-width: 1001px) {\n        width: 220px;\n    }\n    @media screen and (max-width:600px) {\n        width: 100%;\n    }\n"
    ]);
    MoreBrand_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MoreBrand_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 140px;\n    padding: 0px 5px;\n    font-size: 12px;\n    border-radius: 40px;\n    @media screen and (max-width:600px){\n        width: 95px;\n    }\n"
    ]);
    MoreBrand_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var MoreBrand = function(param) {
    var handleBack = param.handleBack, activeCategory = param.activeCategory, ListBrand = param.ListBrand, ListCategory = param.ListCategory, ListProvinceId = param.ListProvinceId, isLoading = param.isLoading;
    var dispatch = (0,es/* useDispatch */.I0)();
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var ref1 = (0,react.useState)(""), selectProvince = ref1[0], setSelectProvince = ref1[1];
    var ref2 = (0,react.useState)(ListBrand), selectList = ref2[0], setSelectList = ref2[1];
    var sortSelectList1 = selectList === null || selectList === void 0 ? void 0 : selectList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.images) !== "";
    });
    var sortSelectList2 = selectList === null || selectList === void 0 ? void 0 : selectList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.images) === "";
    });
    var selectListConcat = sortSelectList1 === null || sortSelectList1 === void 0 ? void 0 : sortSelectList1.concat(sortSelectList2);
    var sliderSettings = {
        320: {
            slidesPerView: 3,
            spaceBetween: 5
        },
        680: {
            slidesPerView: 4,
            spaceBetween: 0
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 5
        },
        1366: {
            slidesPerView: 5,
            spaceBetween: 5
        }
    };
    var swiperRef = (0,react.useRef)();
    var searchListBrand = (0,react.useMemo)(function() {
        var listItem = (0,_to_consumable_array/* default */.Z)(ListBrand);
        if (searchQuery !== "") {
            return listItem === null || listItem === void 0 ? void 0 : listItem.filter(function(item) {
                var ref, ref1;
                return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.title) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.toLowerCase());
            });
        }
        return listItem;
    }, [
        ListBrand,
        searchQuery
    ]);
    var constSelectProvince = (0,react.useMemo)(function() {
        var listItem = (0,_to_consumable_array/* default */.Z)(searchListBrand);
        if (selectProvince !== "0") {
            var listFilterProvince = ListProvinceId === null || ListProvinceId === void 0 ? void 0 : ListProvinceId.map(function(item) {
                return listItem === null || listItem === void 0 ? void 0 : listItem.find(function(it) {
                    var ref;
                    return (it === null || it === void 0 ? void 0 : (ref = it.id) === null || ref === void 0 ? void 0 : ref.toString()) === (item === null || item === void 0 ? void 0 : item.toString());
                });
            });
            var filterProvince = listFilterProvince === null || listFilterProvince === void 0 ? void 0 : listFilterProvince.filter(function(item) {
                return item !== undefined;
            });
            setSelectList(filterProvince);
            return filterProvince;
        }
        return listItem;
    }, [
        ListProvinceId,
        searchListBrand,
        selectProvince
    ]);
    (0,react.useEffect)(function() {
        var listItem = (0,_to_consumable_array/* default */.Z)(constSelectProvince);
        if (activeCategory) {
            setSelectList(listItem === null || listItem === void 0 ? void 0 : listItem.filter(function(item) {
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.parent_cat_id) === null || ref === void 0 ? void 0 : ref.toString()) === (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.toString());
            }));
        }
        if (activeCategory === 0) setSelectList(listItem);
    }, [
        ListBrand,
        activeCategory,
        constSelectProvince,
        searchListBrand
    ]);
    var handleSelectProvince = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (option === undefined) {
                            setSelectProvince("1".toString());
                        }
                        setSelectProvince(option === null || option === void 0 ? void 0 : (ref = option.provinceId) === null || ref === void 0 ? void 0 : ref.toString());
                        return [
                            4,
                            dispatch((0,actions/* fetchProvinceId */.ar)({
                                cityId: option === null || option === void 0 ? void 0 : option.provinceId
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectProvince(option) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeCategory = function(newValue) {
        dispatch((0,actions/* fetchActiveCategory */.To)({
            category: newValue
        }));
    };
    var handleChangeBrand = function(evt) {
        var re = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\W|_]+$/;
        if (evt.target.value === "" || re.test(evt.target.value)) {
            var values = evt.target.value;
            var replace = values.replace(/[.*+?^${}()|[\]\\!@#%&_~]/g, "");
            setSearchQuery(replace);
        }
    };
    var allOption = [
        {
            provinceId: "0",
            provinceName: "Tất cả khu vực"
        }, 
    ];
    var concatProvince = allOption === null || allOption === void 0 ? void 0 : allOption.concat(province);
    var allOptionCategory = [
        {
            id: "0",
            images: "",
            title: "Tất cả"
        },
        {
            id: "1",
            images: "",
            title: "GiftCard"
        }, 
    ];
    var concatCategory = allOptionCategory === null || allOptionCategory === void 0 ? void 0 : allOptionCategory.concat(ListCategory);
    var ref3 = (0,react.useState)(1), itemOffset = ref3[0], setItemOffset = ref3[1];
    var currentItem = (0,react.useMemo)(function() {
        if ((selectListConcat === null || selectListConcat === void 0 ? void 0 : selectListConcat.length) > config/* MAXIMUM_SHOW_BRAND */.k2) {
            var limit = itemOffset * config/* MAXIMUM_SHOW_BRAND */.k2;
            var limit2 = config/* MAXIMUM_SHOW_BRAND */.k2 + (itemOffset - 1) * config/* MORE_BRAND */.Yn;
            if (itemOffset !== 1) {
                return (0,_to_consumable_array/* default */.Z)(selectListConcat.slice(0, limit2));
            }
            return (0,_to_consumable_array/* default */.Z)(selectListConcat.slice(0, limit));
        }
        return (0,_to_consumable_array/* default */.Z)(selectListConcat);
    }, [
        itemOffset,
        selectListConcat
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        style: {
            gap: "1rem"
        },
        id: "targetid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    style: {
                        gap: "12px",
                        cursor: "pointer",
                        width: "fit-content"
                    },
                    onClick: function() {
                        return handleBack(false);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle/* default */.Z, {
                            width: "32px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            scale: "lg",
                            children: "Quay lại"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    style: {
                        gap: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            scale: "lg",
                            children: "Danh mục"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "auto",
                            flexWrap: "wrap",
                            style: {
                                gap: "1rem"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup/* default */.Z, {
                                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                            width: "24px"
                                        }),
                                        scale: "sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            type: "text",
                                            value: searchQuery,
                                            placeholder: "T\xecm thương hiệu",
                                            onChange: function(evt) {
                                                return handleChangeBrand(evt);
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProvinceHome/* default */.Z, {
                                        options: concatProvince,
                                        onOptionChange: handleSelectProvince,
                                        placeHolderText: "Khu vực c\xf3 cửa h\xe0ng",
                                        isDefaultProvince: !false,
                                        isLoading: false,
                                        selectedOption: province === null || province === void 0 ? void 0 : province.find(function(item) {
                                            var ref;
                                            return (item === null || item === void 0 ? void 0 : (ref = item.provinceId) === null || ref === void 0 ? void 0 : ref.toString()) === (selectProvince === null || selectProvince === void 0 ? void 0 : selectProvince.toString());
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                style: {
                    gap: "12px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                            },
                            style: {
                                cursor: "pointer",
                                transform: "rotate(180deg)"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle/* default */.Z, {
                                width: "32px",
                                style: {
                                    transform: "rotate(180deg)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            slidesPerView: 5,
                            pagination: {
                                clickable: true
                            },
                            onSlideChange: function() {
                                return console.log("slide change");
                            },
                            onSwiper: function(swiper) {
                                return console.log(swiper);
                            },
                            spaceBetween: 0,
                            breakpoints: sliderSettings,
                            modules: [
                                swiper_esm/* Navigation */.W_
                            ],
                            onBeforeInit: function(swiper) {
                                swiperRef.current = swiper;
                            },
                            children: concatCategory === null || concatCategory === void 0 ? void 0 : concatCategory.map(function(dt) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                                        variant: new bignumber/* default */.Z(activeCategory).isEqualTo(dt === null || dt === void 0 ? void 0 : dt.id) ? "primary" : "text",
                                        onClick: function() {
                                            return handleChangeCategory(+(dt === null || dt === void 0 ? void 0 : dt.id));
                                        },
                                        children: dt === null || dt === void 0 ? void 0 : dt.title
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle/* default */.Z, {
                                width: "32px",
                                style: {
                                    cursor: "pointer",
                                    transform: "rotate(180deg)"
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Đ\xe3 t\xecm thấy"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            bold: true,
                            color: "warning43",
                            children: [
                                selectList === null || selectList === void 0 ? void 0 : selectList.length,
                                " thương hiệu"
                            ]
                        })
                    ]
                })
            }),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mt: "2rem",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                    size: "small"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridTemplate, {
                    children: currentItem === null || currentItem === void 0 ? void 0 : currentItem.map(function(dt) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (dt === null || dt === void 0 ? void 0 : dt.isNewBrand) ? "/brand/".concat(dt === null || dt === void 0 ? void 0 : dt.id, "?newbrand=true") : "/brand/".concat(dt === null || dt === void 0 ? void 0 : dt.id),
                            children: (dt === null || dt === void 0 ? void 0 : dt.images) !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                height: "auto",
                                borderRadius: "10px",
                                border: "1px solid ".concat(theme.colors.silver),
                                style: {
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: dt === null || dt === void 0 ? void 0 : dt.images,
                                    alt: dt === null || dt === void 0 ? void 0 : dt.title,
                                    style: {
                                        borderRadius: "9px"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                title: dt === null || dt === void 0 ? void 0 : dt.title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/logo/noLogo.png",
                                        alt: dt === null || dt === void 0 ? void 0 : dt.title
                                    })
                                })
                            })
                        });
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                mt: "1rem",
                mb: "1rem",
                children: (selectList === null || selectList === void 0 ? void 0 : selectList.length) - (currentItem === null || currentItem === void 0 ? void 0 : currentItem.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        variant: "secondary",
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {
                            style: {
                                transform: "rotate(90deg)"
                            }
                        }),
                        onClick: function() {
                            return setItemOffset(itemOffset + 1);
                        },
                        children: [
                            "+ ",
                            (selectList === null || selectList === void 0 ? void 0 : selectList.length) - (currentItem === null || currentItem === void 0 ? void 0 : currentItem.length),
                            " thương hiệu"
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_MoreBrand = (MoreBrand);
var CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-95cf703a-0"
})(MoreBrand_templateObject());
var CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-95cf703a-1"
})(MoreBrand_templateObject1());

;// CONCATENATED MODULE: ./src/views/Home/Brand/index.tsx






var Brand = function(param) {
    var ListBrand = param.ListBrand, ListCategory = param.ListCategory, isShowmore = param.isShowmore, category = param.category, price = param.price, ListProvinceId = param.ListProvinceId, isLoading = param.isLoading;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleSelectPrice = function(value) {
        dispatch((0,actions/* fetchActivePrice */.kW)({
            price: value
        }));
    };
    var handleShowMore = function(newValue) {
        dispatch((0,actions/* fetchStatusShowmore */.tV)({
            isShowmore: newValue
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        width: "100%",
        height: "auto",
        children: isShowmore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MoreBrand, {
            handleBack: function(newValue) {
                return handleShowMore(newValue);
            },
            activeCategory: category,
            ListBrand: ListBrand,
            ListCategory: ListCategory,
            ListProvinceId: ListProvinceId,
            isLoading: isLoading
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LessBrand, {
            activePrice: price,
            handleChangePrice: handleSelectPrice,
            handleShowMore: function(newValue) {
                return handleShowMore(newValue);
            },
            ListBrand: ListBrand
        })
    });
};
/* harmony default export */ var Home_Brand = (Brand);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(78258);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(51998);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Menu/config.ts
var Menu_config = __webpack_require__(4449);
;// CONCATENATED MODULE: ./src/views/Home/components/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 61.5%;\n    height: auto;\n    @media screen and (max-width:768px) {\n        width:100%;  \n    }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 30%;\n    height: auto;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    flex-wrap: wrap;\n    margin-top: 150px;\n    ",
        " {\n        margin-top: 60px;\n        @media screen and (max-width:768px) {\n            margin-top: 20px;\n        }\n    }\n    @media screen and (max-width:768px) {\n        margin-top: 120px;\n    }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top:-",
        'px;\n    height: auto;\n    min-height: 100vh;\n    background: url("/images/giftcards/banner.png");\n    background-size: 100% 100%;\n    background-position: center top;\n    background-repeat: no-repeat;\n    z-index: 1;\n    @media screen and (max-width: 768px) and (min-width:601px) {\n        height: 1100px;\n    }\n    @media screen and (max-width: 600px){\n        height: 1000px;\n    }\n'
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 60px;\n    color: ",
        ";\n    font-weight: 700;\n    line-height: 120%; /* 72px */\n    letter-spacing: -1.2px;\n    @media screen and (max-width:1280px) and (min-width:1001px) {\n        font-size: 50px;\n    }\n    @media screen and (max-width:600px) {\n        font-size: 36px;\n    }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            mix-blend-mode: luminosity;\n            opacity: 0.7;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 36px;\n    align-items: center;\n    justify-content: center;\n    /* padding: 4px; */\n    border-radius: 6px;\n    /* border: ",
        "; */\n    cursor: ",
        ";\n    > img {\n        ",
        "\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-column-gap: 8px;\n    gap: 2px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60px;\n    width: 384px;\n    padding: 0px 16px;\n    background: white;\n    border-radius: 16px;\n    justify-content: space-around;\n    align-items: center;\n    margin-top: 12px;\n    @media screen and (max-width: 576px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var ColLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b256157f-0"
})(styles_templateObject());
var ColRight = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b256157f-1"
})(styles_templateObject1());
var RowForBanner = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b256157f-2"
})(styles_templateObject2(), ColLeft);
var ContainerBanner = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b256157f-3"
})(styles_templateObject3(), Menu_config/* MENU_HEIGHT */.d0);
var styles_CsHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-b256157f-4"
})(styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CardImg = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b256157f-5"
})(_templateObject6(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? "2px solid ".concat(theme.colors.gold) : "none";
}, function(param) {
    var isDisable = param.isDisable;
    return isDisable ? "not-allowed" : "default";
}, function(props) {
    return props.isDisable && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var GirdImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b256157f-6"
})(_templateObject7());
var ContainerImage = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b256157f-7"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/views/Home/components/Banner.tsx




var Banner = function() {
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerBanner, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RowForBanner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColLeft, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        flexDirection: "column",
                        style: {
                            gap: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsHeading, {
                                    color: "white",
                                    children: "300+ thương hiệu nổi tiếng tr\xean to\xe0n quốc"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                width: "100%",
                                maxWidth: "600px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            color: "white",
                                            fontSize: [
                                                "12px",
                                                "14px",
                                                "16px"
                                            ],
                                            children: [
                                                "Nền tảng đầu ti\xean cho ph\xe9p sử dụng ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "white",
                                                        whiteSpace: "nowrap",
                                                        fontWeight: "600"
                                                    },
                                                    children: "điểm thưởng"
                                                }),
                                                " để đổi voucher"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerImage, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: "/images/giftcards/dnpay.png?version=1.0",
                                                width: isMobile ? 65 : 81,
                                                height: isMobile ? 22 : 28
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: "/images/giftcards/bsc.png?version=1.0",
                                                width: isMobile ? 82 : 102,
                                                height: isMobile ? 22 : 28
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: "/images/giftcards/onus.png?version=1.0",
                                                width: isMobile ? 85 : 105,
                                                height: isMobile ? 22 : 28
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_Banner = (Banner);

// EXTERNAL MODULE: ./src/state/giftCards/actions.ts
var giftCards_actions = __webpack_require__(59494);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/views/Home/config.ts
var listBank = [
    {
        name: "vndc",
        isDisable: false,
        isActive: !false,
        image: "/images/logo/vndc2.png"
    },
    {
        name: "mb",
        isDisable: false,
        isActive: !false,
        image: "/images/logo/dnpay.png"
    },
    {
        name: "vietcom",
        isDisable: !false,
        isActive: false,
        image: "/images/logo/vietcom.png"
    },
    {
        name: "vietin",
        isDisable: !false,
        isActive: false,
        image: "/images/logo/vietin.png"
    },
    {
        name: "acb",
        isDisable: !false,
        isActive: false,
        image: "/images/logo/acb.png"
    }
];
var listTradeMark = [
    {
        name: "highlands",
        image: "/images/logo/highlands.png"
    },
    {
        name: "phuclong",
        image: "/images/logo/phuclong.png"
    },
    {
        name: "coopmart",
        image: "/images/logo/coopmart.png"
    },
    {
        name: "dingtea",
        image: "/images/logo/dingtea.png"
    },
    {
        name: "jollibee",
        image: "/images/logo/jollibee.png"
    },
    {
        name: "cgv",
        image: "/images/logo/cgv.png"
    },
    {
        name: "vascara",
        image: "/images/logo/vascara.png"
    },
    {
        name: "manuah",
        image: "/images/logo/manuah.png"
    },
    {
        name: "sulwhasoo",
        image: "/images/logo/dingtea.png"
    },
    {
        name: "levis",
        image: "/images/logo/levis.png"
    },
    {
        name: "br",
        image: "/images/logo/br.png"
    },
    {
        name: "kfc",
        image: "/images/logo/kfc.png"
    },
    {
        name: "galaxyplay",
        image: "/images/logo/galaxyplay.png"
    },
    {
        name: "go",
        image: "/images/logo/go.png"
    },
    {
        name: "starbucks",
        image: "/images/logo/starbucks.png"
    }, 
];

;// CONCATENATED MODULE: ./src/views/Home/components/Vouchers.tsx



function Vouchers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 440px;\n    height: 0px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 110px;\n    left: 62.5%;\n    @media screen and (max-width:768px) {\n        position: fixed;\n        width: 100%;\n        height: auto;\n        top: 370px;\n        left: 10%;\n    }\n    @media screen and (max-width:1280px) and (min-width:1001px) {\n        width: 370px;\n    }\n    @media screen and (max-width:768px) and (min-width:601px) {\n        width: 620px;\n    }\n    @media screen and (max-width:600px) {\n        width: 100%;\n        position: fixed;\n        height: auto;\n        top: 320px;\n        left: 0px;\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n"
    ]);
    Vouchers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Vouchers_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: auto; \n    border-radius: 28px;\n    padding: 1.5rem 2rem;\n    background: ",
        ";\n    box-shadow: ",
        ";\n    z-index: 10;\n"
    ]);
    Vouchers_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Vouchers = function(param) {
    var ListBrand = param.ListBrand;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleShowMore = function(newValue) {
        dispatch((0,actions/* fetchStatusShowmore */.tV)({
            isShowmore: newValue
        }));
    };
    var filernoneImg = ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.images) !== "";
    });
    var sliceListBrand = filernoneImg === null || filernoneImg === void 0 ? void 0 : filernoneImg.slice(0, 15);
    console.log("asdasdadasd", sliceListBrand);
    var countListBrandMore = (ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.length) - (sliceListBrand === null || sliceListBrand === void 0 ? void 0 : sliceListBrand.length);
    var handleClickSwap = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            router.push("/order")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,giftCards_actions/* fetchStatusScreen */.an)({
                                isActiveScreen: 0
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickSwap() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickShowMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleShowMore(!false)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            document.getElementById("targetid").scrollIntoView({
                                behavior: "smooth"
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickShowMore() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Vouchers_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vouchers_CsFlex, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                style: {
                    gap: "14px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/logoBlack.png?version=1.1",
                            alt: "",
                            width: "180px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        flexDirection: "column",
                        style: {
                            gap: "14px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                textTransform: "uppercase",
                                bold: true,
                                color: "black",
                                children: "Voucher tr\xean nền tảng blockchain"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/giftcards/vouchers.png",
                                    alt: "",
                                    style: {
                                        width: "100%",
                                        height: "auto"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "black",
                        bold: true,
                        children: "H\xccNH THỨC ĐỔI ĐIỂM"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GirdImage, {
                        children: listBank === null || listBank === void 0 ? void 0 : listBank.map(function(dt) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImg, {
                                isActive: dt === null || dt === void 0 ? void 0 : dt.isActive,
                                isDisable: dt === null || dt === void 0 ? void 0 : dt.isDisable,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: dt === null || dt === void 0 ? void 0 : dt.image,
                                    alt: ""
                                })
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "black",
                        bold: true,
                        children: "VOUCHER C\xd3 SẴN TẠI"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GirdImage, {
                        children: sliceListBrand === null || sliceListBrand === void 0 ? void 0 : sliceListBrand.map(function(dt) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (dt === null || dt === void 0 ? void 0 : dt.isNewBrand) ? "/brand/".concat(dt === null || dt === void 0 ? void 0 : dt.id, "?newbrand=true") : "/brand/".concat(dt === null || dt === void 0 ? void 0 : dt.id),
                                children: (dt === null || dt === void 0 ? void 0 : dt.images) !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImg, {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: dt === null || dt === void 0 ? void 0 : dt.images,
                                        alt: "",
                                        style: {
                                            width: "auto",
                                            height: "100%"
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    width: "26px",
                                    height: "26px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/logo/noLogo.png",
                                        alt: dt === null || dt === void 0 ? void 0 : dt.title
                                    })
                                })
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        onClick: handleClickShowMore,
                        style: {
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "primary",
                            style: {
                                textDecoration: "underline"
                            },
                            children: "+ 300 thương hiệu to\xe0n quốc"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            style: {
                                borderRadius: "40px"
                            },
                            onClick: handleClickSwap,
                            children: "ĐỔI THẺ QU\xc0 TẶNG NGAY"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_Vouchers = (Vouchers);
var Vouchers_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eb2f559-0"
})(Vouchers_templateObject());
var Vouchers_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eb2f559-1"
})(Vouchers_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.boxShadow;
});

;// CONCATENATED MODULE: ./src/views/Home/index.tsx









var Home = function() {
    (0,home/* UseCoreHome */.au)();
    var dataHome = (0,home/* GetDataHome */.zs)();
    var ListBrand = dataHome.ListBrand, ListCategory = dataHome.ListCategory, isShowmore = dataHome.isShowmore, category = dataHome.category, price = dataHome.price, ListProvinceId = dataHome.ListProvinceId, isLoading = dataHome.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Vouchers, {
                ListBrand: ListBrand
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Banner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    width: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColLeft, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Brand, {
                                ListBrand: ListBrand,
                                ListCategory: ListCategory,
                                isShowmore: isShowmore,
                                category: category,
                                price: price,
                                ListProvinceId: ListProvinceId,
                                isLoading: isLoading
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {});
};
IndexPage.chains = wagmi/* SUPPORT_CHAIN_GIFTCARDS */.fd;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 75660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HO": function() { return /* binding */ toLowerCaseNonAccentVietnamese; },
/* harmony export */   "OF": function() { return /* binding */ latiniseText; }
/* harmony export */ });
/* unused harmony exports Latinise, latinise */
var Latinise = {
    latin_map: {
        τ: "t",
        Τ: "T"
    }
};
var latinise = function(input) {
    return input.replace(/[^A-Za-z0-9[\] ]/g, function(x) {
        return Latinise.latin_map[x] || x;
    });
};
var toLowerCaseNonAccentVietnamese = function(text) {
    var str = text.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
    str = str.replace(/\u02C6|\u0306|\u031B/g, "");
    return str;
};
var latiniseText = function(text) {
    var str = text.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    return str;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1372,8255,1023,6207,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);